import type { LucideIcon } from 'lucide-react';
export function FlowMark({ className = '' }: { className?: string }) {
  return (
    <span className={`flow-mark ${className}`} aria-hidden="true">
      <span />
      <span />
      <span />
      <i />
    </span>
  );
}
export function PageIntro({
  eyebrow,
  title,
  description,
  icon: Icon,
  as = 'h1',
  tone = 'teal',
}: {
  eyebrow: string;
  title: string;
  description: string;
  icon: LucideIcon;
  as?: 'h1' | 'p';
  tone?: 'teal' | 'violet' | 'amber';
}) {
  const Heading = as;
  return (
    <header className={`page-intro page-intro--${tone}`}>
      <div className="page-intro-copy">
        <p className="page-intro-eyebrow">
          <span className="eyebrow-dot" />
          {eyebrow}
        </p>
        <Heading className="page-intro-title">{title}</Heading>
        <p className="page-intro-description">{description}</p>
      </div>
      <div className="page-intro-art" aria-hidden="true">
        <FlowMark />
        <Icon strokeWidth={1.6} />
        <span className="page-intro-orbit-dot" />
      </div>
    </header>
  );
}
